import { defaultHttpClient } from '../../httpClient';
import type { GoodsPIPNInfoResponse } from './types';

/**
 * - 상품정보제공고시 조회 API
 * - GET /api/v2/goods/{sno}/pipn_info/
 */
export const getGoodsPIPNInfo = (goodsSno: number) => {
  return defaultHttpClient
    .request<GoodsPIPNInfoResponse>({
      method: 'GET',
      url: `/api/v2/goods/${goodsSno}/pipn_info/`,
    })
    .then(result => result.data);
};
